import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    backgroundColor: theme.colors.modal__background_primary,
    maxWidth: 580
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6)
  },
  callouts: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4)
  },
  notification: {
    margin: 0,
    padding: theme.spacing(4)
  },
  tip: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.spacing(2)
  },
  tipLabel: {
    fontWeight: 600
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  methodChooser: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  radioLabel: {
    color: theme.colors.text_secondary,
    fontSize: 14,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(3)
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4)
  }
});

export default makeStyles(styles);
